import { Injectable } from '@angular/core';

import { getPicksCount } from '../../../../../../core/utils';
import { CriteriaType, IRewardToken } from '../../../../reward-tokens.model';
import { TokenValidationInput, TokensCriteriaValidatorBase } from '../../criteria-validator-base.service';

@Injectable()
export class BetAndGetMinimumLegsValidator extends TokensCriteriaValidatorBase<IRewardToken, CriteriaType> {
    override type = CriteriaType.MinimumLegs;
    isValid(token: IRewardToken, state: TokenValidationInput): boolean {
        const picksCount = getPicksCount(state.selectedPicks);

        return token.minimumLegs ? picksCount >= token.minimumLegs : true;
    }
}
